import { useGetMyAccount } from '@queries/Account'
import { Account } from '@models/Account'

export const useGetAccount = (): Account | undefined => {
  const { data: user } = useGetMyAccount()
  return user
}

export default useGetAccount
